import { useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/dist/SplitText';

gsap.registerPlugin(SplitText);

export function useLoaderLogic() {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const ctx = gsap.context(() => {
            const headers = gsap.utils.toArray('.text');
            const tl = gsap.timeline();

            headers.forEach((h1, i) => {
                const chars = SplitText.create(h1, {
                    type: 'chars'
                });

                tl.to(chars.chars, {
                    transform: `translate3d(-0%,-250%,0)`,
                    stagger: { each: 0.1, from: i % 2 === 0 ? 'start' : 'end' },
                    ease: 'power3.out'
                }, i === 0 ? 'a+2' : '>')
                    .to(chars.chars, {
                        transform: `translate3d(0%,-300vh,0)`,
                        stagger: { each: 0.1, from: i % 2 === 0 ? 'end' : 'start' },
                        ease: 'power2.inOut'
                    }, '>+=0.1');
            });

            tl.to('.loader-container', {
                autoAlpha: 0,
                duration: 0.8,
                ease: 'power2.inOut',
                onComplete: () => {
                    setIsVisible(false);
                }
            }, '>-0.5').to('.Main_motto',{autoAlpha:1},'>-0.5')

            // Animate navbar if it exists
            const navbar = document.querySelector('#navbar');
            if (navbar) {
                tl.fromTo('#navbar',
                    { autoAlpha: 0, visibility: 'visible' },
                    { autoAlpha: 1, ease: 'sin.in', duration: 2 },
                    'a'
                );
            }

            // Animate motto elements if they exist (for desktop)
            const mottoText = document.querySelector('.mottoText');
            const model3D = document.querySelector('.model3D');
            const canvas = document.querySelector('#canvas');

            if (mottoText) {
                tl.to(".mottoText", { transform: 'translate3D(0,0,0)', duration: 1.5,autoAlpha:1 }, "a");
            }
            if (model3D) {
                tl.to(".model3D", { autoAlpha: 1, duration: 2 }, "a");
            }
            if (canvas) {
                tl.fromTo("#canvas", {
                    autoAlpha: 0,
                    transform: "translate3D(0,10vh,0)"
                }, {
                    autoAlpha: 1,
                    transform: "translate3D(0,0,0)"
                }, "a");
            }
            // Remove loader after all animations complete
            
        });

        return () => ctx.revert();
    }, []);

    return { isVisible };
}